import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-3652">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-3653">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-3654">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-3655">
            <ArrowLeft className="w-5 h-5" data-id="element-3656" />
            <span className="text-sm" data-id="element-3657">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-3658">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-3659">
          Términos y Condiciones
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-3660">
          <p data-id="element-3661">
            Al registrarte y participar en el 48 Hrs AI Cash Machine
            Masterclass, aceptas los siguientes términos y condiciones:
          </p>

          <section data-id="element-3662">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3663">
              1. Aceptación de Términos
            </h2>
            <p data-id="element-3664">
              Al acceder y utilizar este sitio web y registrarte para el evento,
              aceptas estar sujeto a estos términos y condiciones, todas las
              leyes y regulaciones aplicables.
            </p>
          </section>

          <section data-id="element-3665">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3666">
              2. Uso del Servicio
            </h2>
            <p data-id="element-3667">
              El contenido proporcionado en el masterclass es solo para fines
              educativos e informativos. No garantizamos resultados específicos
              de ingresos o éxito comercial.
            </p>
          </section>

          <section data-id="element-3668">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3669">
              3. Propiedad Intelectual
            </h2>
            <p data-id="element-3670">
              Todo el contenido, materiales, y recursos proporcionados son
              propiedad de 48 Hrs AI Cash Machine y están protegidos por
              derechos de autor. No está permitida la reproducción o
              distribución sin autorización expresa.
            </p>
          </section>

          <section data-id="element-3671">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3672">
              4. Limitación de Responsabilidad
            </h2>
            <p data-id="element-3673">
              48 Hrs AI Cash Machine no será responsable de ningún daño directo,
              indirecto, incidental o consecuente que resulte del uso o la
              imposibilidad de usar nuestros servicios.
            </p>
          </section>

          <section data-id="element-3674">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3675">
              5. Consentimiento para Mensajes SMS
            </h2>
            <p className="mb-4" data-id="element-3676">
              Al marcar la casilla de consentimiento SMS durante el registro,
              aceptas recibir mensajes SMS/texto recurrentes de True Marketer
              LLC al número móvil proporcionado, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3677">
              <li data-id="element-3678">Actualizaciones del programa</li>
              <li data-id="element-3679">Información de capacitación</li>
              <li data-id="element-3680">Mensajes de marketing/promocionales</li>
            </ul>
            <p className="mt-4" data-id="element-3681">
              Estos mensajes son enviados mediante un sistema de marcación
              telefónica automática/tecnología automatizada. La frecuencia de
              los mensajes varía. Pueden aplicar tarifas de mensajes y datos.
            </p>
            <p className="mt-4" data-id="element-3682">
              <strong className="text-white" data-id="element-3683">Cancelación:</strong> Responde STOP
              para cancelar.
            </p>
            <p className="mt-2" data-id="element-3684">
              <strong className="text-white" data-id="element-3685">Ayuda:</strong> Responde HELP para
              ayuda.
            </p>
            <p className="mt-4" data-id="element-3686">
              El consentimiento no es una condición de compra.
            </p>
          </section>

          <section data-id="element-3687">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3688">
              6. Modificaciones
            </h2>
            <p data-id="element-3689">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. El uso continuado del servicio después de cambios
              constituye la aceptación de los nuevos términos.
            </p>
          </section>

          <section data-id="element-3690">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3691">
              7. Garantía y Reembolsos
            </h2>
            <p data-id="element-3692">
              Para productos de pago, ofrecemos una garantía de satisfacción de
              30 días. Si no estás satisfecho con el producto, puedes solicitar
              un reembolso completo dentro de los primeros 30 días de la compra.
            </p>
          </section>

          <section data-id="element-3693">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3694">
              8. Descargo de Responsabilidad sobre Resultados
            </h2>
            <p className="mb-4" data-id="element-3695">
              48Hrs AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos.
            </p>
            <p className="mb-4" data-id="element-3696">
              El éxito depende en parte del tiempo que dediques y de tu
              implementación de las guías, estrategias y soporte proporcionados.
            </p>
            <p className="mb-4" data-id="element-3697">
              Todo el contenido, entrenamientos, artículos y material educativo
              tiene fines formativos únicamente y no debe interpretarse como
              asesoría financiera, legal o de inversión.
            </p>
            <p data-id="element-3698">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos.
            </p>
          </section>

          <section data-id="element-3699">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3700">
              9. Afiliaciones
            </h2>
            <p data-id="element-3701">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc. Además, este sitio no está avalado, patrocinado ni
              aprobado por Google ni Meta de ninguna manera.
            </p>
          </section>

          <section data-id="element-3702">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3703">Contacto</h2>
            <p data-id="element-3704">
              Para preguntas sobre estos términos, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-3705">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-3706">
            <p className="text-gray-500 text-sm" data-id="element-3707">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-3708">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3709">
          <p className="text-gray-600 text-xs mb-2" data-id="element-3710">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-3711">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-3712">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-3713">
            <span className="text-white" data-id="element-3714">Términos</span>
            <span className="text-gray-600" data-id="element-3715">|</span>
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-3716">
              Privacidad
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}